import {CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const Spinner = ({className, ...props}: any) => (
  <CircularProgressbar className={`animate-spin ${className}`} value={20} {...props} />
);

export default Spinner;
